class RteContent extends HTMLElement {
  constructor() {
    super();

    this.$assets = Array.from(this.querySelectorAll("img, iframe"));

    this.parentClass();

    this.tables();
  }

  parentClass() {
    this.$assets.forEach(($asset) => {
      if (
        ($asset.style.marginLeft === "auto" &&
          $asset.style.marginRight === "auto") ||
        $asset.parentNode.style.textAlign === "center" ||
        $asset.tagName === "IFRAME"
      ) {
        const $nextSibling = $asset.nextSibling;
        const $wrapper = document.createElement("DIV");
        $wrapper.classList.add("extended-container");
        $asset.insertAdjacentElement("afterend", $wrapper);
        $wrapper.appendChild($asset);
        if ($nextSibling && $nextSibling.nodeType === Node.TEXT_NODE) {
          $wrapper.appendChild();
        }
      }
    });
  }

  tables() {
    this.querySelectorAll("table").forEach(($table) => {
      const $wrapper = document.createElement("custom-scroll");

      $wrapper.classList.add("rte__table-wrapper");

      $table.insertAdjacentElement("afterend", $wrapper);
      $wrapper.appendChild($table);
    });
  }
}

customElements.define("rte-content", RteContent);
